import { CommonModule, LowerCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TealiumModule } from '@common/components/tealium/tealium.module';
import { TripSummaryService } from '@common/services/my-booking/trip-summary.service';
import { TextTooltipModule } from '@lib/components';
import { TooltipDirectiveModule } from '@lib/directives';
import { DateFormatModule, DateFormatPipe, MetaUrlModule, StaticMsgModule } from '@lib/pipes';
import { BoundTitleComponent } from './sub-components/bound-title/bound-title.component';
import { ArrivalComponent } from './sub-components/flight-item/arrival/arrival.component';
import { DepartureComponent } from './sub-components/flight-item/departure/departure.component';
import { EstimateDateTimeComponent } from './sub-components/flight-item/estimate-datetime/estimate-datetime.component';
import { FlightItemComponent } from './sub-components/flight-item/flight-item.component';
import { InFlightServiceComponent } from './sub-components/flight-item/waiting/in-flight-service/in-flight-service.component';
import { WaitingComponent } from './sub-components/flight-item/waiting/waiting.component';
import { TripSummaryComponent } from './trip-summary.component';

@NgModule({
  declarations: [
    TripSummaryComponent,
    ArrivalComponent,
    BoundTitleComponent,
    DepartureComponent,
    FlightItemComponent,
    InFlightServiceComponent,
    WaitingComponent,
    EstimateDateTimeComponent,
  ],
  imports: [
    CommonModule,
    StaticMsgModule,
    FormsModule,
    TextTooltipModule,
    TooltipDirectiveModule,
    DateFormatModule,
    TealiumModule,
    MetaUrlModule,
  ],
  providers: [LowerCasePipe, TripSummaryService, DateFormatPipe],
  exports: [TripSummaryComponent],
})
export class TripSummaryModule {}
